import useApiMutation from '_api/mutations/useApiMutation';
import { Resource, ResourcePayload } from '_api/types';

export const UPDATE_RESOURCE_KEY = 'update-resource-key';

export const useUpdateResource = () => {
  return useApiMutation<Resource, ResourcePayload>(
    () => '/resource',
    'put',
    {},
    {
      mutationKey: [UPDATE_RESOURCE_KEY],
    },
  );
};
